import(/* webpackMode: "eager" */ "/vercel/path0/src/app/tr/blog/botoks-sonrasi-alkol-aliminin-sonuclari-bilimsel-etkiler-klinik-bulgular-ve-estetik-riskler/page.tsx");
